(() => {
  document.querySelectorAll('[data-trade-builder]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const find = (selector) => root.querySelector(selector);
    const quantity = find('[name="quantity"]');
    const choices = [...root.querySelectorAll('[name="presentation"]')];
    const quote = find('[data-quote]');
    const labels = { standard: 'Standard kit', insert: 'Branded insert', custom: 'Custom outer packaging' };
    const update = () => {
      const count = Number(quantity.value);
      const valid = quantity.value !== '' && Number.isSafeInteger(count) && count >= 10 && count <= 100000;
      find('[data-error]').hidden = valid;
      quantity.setAttribute('aria-invalid', String(!valid));
      quote.setAttribute('aria-disabled', String(!valid));
      root.querySelectorAll('[data-quantity]').forEach((button) => button.setAttribute('aria-pressed', String(valid && Number(button.dataset.quantity) === count)));
      choices.forEach((choice) => {
        choice.disabled = !valid || count < Number(choice.dataset.minimum);
        if (choice.disabled && choice.checked) choices[0].checked = true;
      });
      const selected = choices.find((choice) => choice.checked).value;
      root.dataset.presentation = selected;
      const organisation = find('[name="organisation"]').value.trim();
      root.querySelectorAll('[data-brand-name]').forEach((node) => { node.textContent = organisation || 'Your organisation'; });
      find('[data-preview-label]').textContent = labels[selected];
      find('[data-summary]').textContent = valid ? `${count.toLocaleString()} kits · ${labels[selected]}` : 'Choose at least 10 kits';
      find('[data-cards-count]').textContent = valid ? (count * 2).toLocaleString() : '—';
      find('[data-pens-count]').textContent = valid ? count.toLocaleString() : '—';
      find('[data-tier]').textContent = valid ? (count < 25 ? 'Pilot order' : count < 100 ? 'Practice order' : 'Programme order') : 'Your order';
      find('[data-order-note]').textContent = !valid ? 'Enter a whole number from 10 to 100,000. For larger orders, email us directly.' : count < 25 ? 'Branded inserts available from 25 kits. Custom outer packaging from 100.' : count < 100 ? 'Branded inserts available. Custom outer packaging from 100 kits.' : 'All presentation options available to discuss with your quote.';
      if (!valid) { quote.removeAttribute('href'); return; }
      const body = ['Hello Edward,', '', 'I would like a quote for:', `Quantity: ${count} kits`, `Presentation: ${labels[selected]}`, `Contents: ${count * 2} stainless steel plates and ${count} engraving pens`, '', `Organisation: ${organisation || '[your organisation]'}`, `Destination country: ${find('[name="country"]').value.trim() || '[your country]'}`, `Intended use: ${find('[name="use"]').value}`, '', 'Please confirm pricing, shipping, availability and lead time.', '', 'Thank you.'].join('\r\n');
      quote.href = `mailto:contact@robinsandcoleman.com?subject=${encodeURIComponent('Volume enquiry — Crypto Seed Bank')}&body=${encodeURIComponent(body)}`;
    };
    root.addEventListener('input', update);
    root.addEventListener('change', update);
    root.querySelectorAll('[data-quantity]').forEach((button) => button.addEventListener('click', () => { quantity.value = button.dataset.quantity; update(); }));
    quote.addEventListener('click', (event) => { if (quote.getAttribute('aria-disabled') === 'true') { event.preventDefault(); quantity.focus(); } });
    update();
  });
  document.querySelectorAll('[data-kit-explorer]').forEach((root) => {
    const buttons = [...root.querySelectorAll('[data-kit-part]')];
    const panels = [...root.querySelectorAll('[data-kit-panel]')];
    buttons.forEach((button) => button.addEventListener('click', () => {
      buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      panels.forEach((panel) => { panel.hidden = panel.dataset.kitPanel !== button.dataset.kitPart; });
    }));
  });
})();
